module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R.L. Stine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, "), _c('I', [_vm._v("The Little Shop of Monsters")]), _vm._v(" and "), _c('I', [_vm._v("Mary McScary")]), _vm._v(". R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RBY0dq/tc-custom/9780545820578.jpg?1729379508139",
      "alt": "This image is the cover for the book Shocker on Shock Street, Classic Goosebumps"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Shocker on Shock Street, Classic Goosebumps\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Two friends must survive being scared to death at a horror theme park in this creeptastic adventure from the Master of Fright.")]), _c('br'), _c('br'), _vm._v("Erin Wright and her best friend, Marty, love horror movies. Especially Shocker on Shock Street movies. All kinds of scary creatures live on Shock Street. The Toadinator. Ape Face. The Mad Mangler."), _c('br'), _c('br'), _vm._v("But when Erin and Marty visit the new Shocker Studio Theme Park, they get the scare of their lives. First their tram gets stuck in The Cave of the Living Creeps. Then they’re attacked by a group of enormous praying mantises!"), _c('br'), _c('br'), _vm._v("Real life is a whole lot scarier than the movies. But Shock Street isn’t really real. Is it?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Scholastic\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0